import { render, staticRenderFns } from "./EditorCommandsList.vue?vue&type=template&id=7aeafece&scoped=true"
import script from "./EditorCommandsList.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorCommandsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditorCommandsList.vue?vue&type=style&index=0&id=7aeafece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeafece",
  null
  
)

export default component.exports